import React, { useEffect } from 'react'
import { MetricTimeUnit } from 'enums'

import { createMetric } from 'utils/runSearchUtil'
import { getInsightContentData } from 'features/insightContent/asyncThunks'
import { getMetricSeries } from 'utils/measureTypeUtil'
import { getMeasureTypeByCountType } from 'components/insightContent/utils/utils'
import { CountTypeStrings } from 'enums/CountType'
import { useAppDispatch } from 'app/hooks'
import { InsightContentSettingType } from 'components/insightContent/types'
import InsightContentType from 'components/insightContent/enum/InsightContentType'
import useRefreshTimestamp from 'hooks/useRefreshTimestamp'

const createSearch = (detailSetting: InsightContentSettingType, countType: CountTypeStrings) => {
  const { precision, topicId, selectionFilter } = detailSetting
  if (!selectionFilter) {
    return null
  }

  const timeUnits = [MetricTimeUnit.ALL]
  const option = {
    forceNotScale: false
  }
  const measure = getMeasureTypeByCountType(countType)

  return createMetric(
    -1,
    '',
    precision,
    [topicId],
    selectionFilter,
    getMetricSeries(measure),
    timeUnits,
    option
  )
}

const RunSearchEffect = ({
  detailSetting,
  countType,
  children
}: {
  detailSetting: InsightContentSettingType
  countType: CountTypeStrings
  children: any
}) => {
  const dispatch = useAppDispatch()
  const refreshTimestamp = useRefreshTimestamp()

  useEffect(() => {
    const searches = createSearch(detailSetting, countType)

    dispatch(
      getInsightContentData({
        insightContentType: InsightContentType.TRENDING_SINGLE_MEASURE,
        searches: [searches!],
        timestamp: refreshTimestamp
      })
    )
  }, [dispatch, detailSetting, countType, refreshTimestamp])

  return <>{children}</>
}

export default RunSearchEffect
